export const GET_PRODUCTS = 'zola/cards/product/GET_PRODUCTS';
export const LOADING_PRODUCTS = 'zola/cards/product/LOADING_PRODUCTS';
export const PRODUCTS_LOADED = 'zola/cards/product/PRODUCTS_LOADED';
export const PRODUCTS_ERROR = 'zola/cards/product/PRODUCTS_ERROR';
export const RESET_PRODUCTS = 'zola/cards/product/RESET_PRODUCTS';
